import { fetchJSON } from "../helpers/fetcher";
import { getEndpoint, ENVIRONMENT } from "./endpoints";

const logsUrl = getEndpoint(ENVIRONMENT)?.logs as string

export class LogsService {
    static get = async (): Promise<any> => {
        return await fetchJSON(logsUrl, "GET");
    };
}

export const logsMock = [
    {
        log_name: "Product Bamboo Watch updated",
        log_content: {
            description: "Product Bamboo Watch updated successfully in Veeqo. ( 2024-03-06 14:20)"
        },
        log_status: "viewed",
        createdAt: new Date("2024-03-06").toISOString()
    },
    {
        log_name: "Product Bamboo Watch created successfully",
        log_content: {
            description: "Product Bamboo Watch created successfully in Veeqo. ( 2024-03-06 12:34)"
        },
        log_status: "received",
        createdAt: new Date("2024-03-06").toISOString()
    },
    {
        log_name: "Product Black Watch fail to update",
        log_content: {
            description: "Product Black Watch fail to update in Veeqo. ( 2024-03-05 10:20)"
        },
        log_status: "open",
        createdAt: new Date("2024-03-05").toISOString()
    },
    {
        log_name: "Product Black Watch created successfully in Veeqo",
        log_content: {
            description: "Product Black Watch created successfully in Veeqo. ( 2024-02-29 10:20)"
        },
        log_status: "closed",
        createdAt: new Date("2024-02-29").toISOString()
    },
]
